import { NucleoBrain, NucleoContent, NucleoGolfFlag } from '@lyearn/icons';

import { MGSAEntityTypes } from './type';

export const ICON_CONFIG = {
  [MGSAEntityTypes.Mindsets]: NucleoBrain,
  [MGSAEntityTypes.Skills]: NucleoContent,
  [MGSAEntityTypes.Goals]: NucleoGolfFlag,
};
